import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APIKeyDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.APIKeyDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APIKeyDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Key = null;
this.Active = false;
this.ActiveUntil = null;
this.CreatedOn = null;
this.LastUsed = null;
this.APIKeyDTOKey = null;
this._key = this.APIKeyDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
Key:any;
Active:any;
ActiveUntil:any;
CreatedOn:any;
LastUsed:any;
private _APIKeyDTOKey:any;
get APIKeyDTOKey(): any {
    return this._APIKeyDTOKey;
  }
set APIKeyDTOKey(value: any) {
    this._APIKeyDTOKey = value;
    this._key = value;
  }

static ToDTO(key: any): any{let dto = new Domain.APIKeyDTO();
dto.Id = key?.Id;
dto.Active = key?.Active;
dto.ActiveUntil = key?.ActiveUntil;
dto.LastUsed = key?.LastUsed;
dto.Key = key?.Key;
dto.Name = key?.Name;
dto.CreatedOn = key?.CreatedOn;
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.APIKeyDTOKey == null || $this.APIKeyDTOKey == 0;
            }


}